export default __webpack_public_path__ + "static/media/blog-16.36976e88.jpeg";